/**
 * All Deployments: compact server metadata for Apprise rows (name, OS, VM size,
 * region, private IP, infra / app status), taken from the API's `server` summary.
 */
import clsx from 'clsx'
import type { AppriseServerSummary } from '@/types'
import {
  APP_TRACK_LABELS, APP_TRACK_TONE, INFRA_TRACK_LABELS, INFRA_TRACK_TONE, serverSummaryParts,
} from './appriseDetail'
import styles from './AppriseDeployment.module.css'

export function AppriseServerSummaryCell({ server }: { server: AppriseServerSummary | null | undefined }) {
  if (!server) return null
  const parts = serverSummaryParts(server)
  return (
    <div className={styles.serverChips} data-testid="apprise-server-summary">
      {parts.map((p, i) => <span key={`${p}-${i}`} className={i === 0 ? styles.serverName : undefined}>{p}</span>)}
      <span className={clsx(styles.statusChip, styles[INFRA_TRACK_TONE[server.infra_status] ?? 'muted'])}>
        Infra: {INFRA_TRACK_LABELS[server.infra_status] ?? server.infra_status}
      </span>
      <span className={clsx(styles.statusChip, styles[APP_TRACK_TONE[server.app_status] ?? 'muted'])}>
        App: {APP_TRACK_LABELS[server.app_status] ?? server.app_status}
      </span>
    </div>
  )
}
